<template>
	<TeamListCardLayout :class="classes">
		<template #favorite>
			<Skeleton class="team-list-skeleton-card__skeleton" />
		</template>
		<template #name>
			<Skeleton class="team-list-skeleton-card__skeleton" />
		</template>
		<template #leads>
			<Skeleton class="team-list-skeleton-card__skeleton" />
		</template>
		<template #members>
			<Skeleton class="team-list-skeleton-card__skeleton" />
		</template>
		<template #chevron>
			<Skeleton class="team-list-skeleton-card__skeleton" />
		</template>
	</TeamListCardLayout>
</template>

<script>
import Skeleton from "primevue/skeleton";
import TeamListCardLayout from "./TeamListCardLayout";

export default {
	name: "TeamListSkeletonCard",
	components: {
		TeamListCardLayout,
		Skeleton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"team-list-skeleton-card": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.team-list-skeleton-card {
	min-height: 1.875rem;
}

.team-list-skeleton-card__skeleton {
	margin-right: 1rem;
}
</style>
